import { Outlet, NavLink, Link } from "react-router-dom";
import { Radar, Heart, History, Clock, Settings, LineChart, Receipt } from "lucide-react";

const navItems = [
  { to: "/admin", label: "Research", icon: Radar, testid: "nav-research", exact: true },
  { to: "/admin/schedules", label: "Schedules", icon: Clock, testid: "nav-schedules" },
  { to: "/admin/analytics", label: "Analytics", icon: LineChart, testid: "nav-analytics" },
  { to: "/admin/orders", label: "Orders", icon: Receipt, testid: "nav-orders" },
  { to: "/admin/history", label: "History", icon: History, testid: "nav-history" },
  { to: "/admin/favorites", label: "Favorites", icon: Heart, testid: "nav-favorites" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
];

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Top Nav */}
      <header className="border-b border-zinc-200 bg-white sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-3 group" data-testid="logo-link">
            <div className="w-9 h-9 klein-bg flex items-center justify-center">
              <Radar size={20} strokeWidth={2.5} color="#ffffff" />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-black text-base tracking-tighter" style={{ fontFamily: "Outfit" }}>
                WINNERCIRCLE
              </span>
              <span className="micro-label">E-COM Research Agent</span>
            </div>
          </Link>
          <nav className="flex items-center gap-1" data-testid="main-nav">
            {navItems.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-3 h-10 text-[11px] uppercase tracking-wider font-bold border transition-all ${
                    isActive
                      ? "bg-zinc-900 text-white border-zinc-900"
                      : "bg-white text-zinc-900 border-transparent hover:border-zinc-900"
                  }`
                }
              >
                <it.icon size={14} strokeWidth={2.5} />
                <span className="hidden sm:inline">{it.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-zinc-200 bg-zinc-50">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-2 h-2 bg-emerald-500 rounded-full blink-dot" />
            <span className="micro-label">SYSTEM ONLINE · ONTARIO, CANADA</span>
          </div>
          <div className="micro-label">CLAUDE SONNET 4.5 · CJ DROPSHIPPING · TIKTOK / INSTAGRAM</div>
        </div>
      </footer>
    </div>
  );
}
